import { useCallback, useMemo } from "react";

import { ValidFabricStateTypes } from "../models/state";

import { Reducer, AnyAction } from "./fabricReducer.types";
import { useFabricState } from "./fabricState";

export const useFabricReducer = <S extends ValidFabricStateTypes>(
  reducer: Reducer,
  namespace: string,
): {
  state: S;
  dispatch: (action: AnyAction) => void;
} => {
  const [state, setState] = useFabricState<S>({
    key: `${namespace} - reducer`,
    default: reducer(undefined, { type: "@@INIT" }),
  });

  const dispatch = useCallback(
    (action: AnyAction) => {
      const newState = reducer(state, action);
      setState(newState);
    },
    [setState, state, reducer],
  );

  return useMemo(() => ({ state, dispatch }), [state, dispatch]);
};
